module.exports = __webpack_public_path__ + "img/1538217428.1ad75761.jpg";